var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.88,12l-7.52,6.24L15,19l9-7.52L15,4l-.65.76L21.88,11H0v1Z","transform":"translate(0 -4)","style":{"fillRule":"evenodd"}}));
}

ArrowRight.defaultProps = {"id":"bf2db89f-8079-469e-ad59-eed45e816ce7","data-name":"Layer 1","viewBox":"0 0 24 15","width":"100%","height":"100%"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
